module.exports = __webpack_public_path__ + "static/recruit_home__reason-opportunity-9bfa6546fc639c9293df3be490cc9f55.png";